<template>
  <div class="page page-supply-info-index input-page">
    <div class="info-list">
      <div class="info-item">
        <div class="label">签约标识</div>
        <div class="value">{{ signInfo.signFlagDesc }}</div>
      </div>
      <div class="info-item">
        <div class="label">签约状态</div>
        <div class="value">{{ signInfo.signStateDesc }}</div>
      </div>
      <div class="info-item">
        <div class="label">签约描述</div>
        <div class="value">{{ signInfo.signMsg }}</div>
      </div>
      <div class="info-item">
        <div class="label">人脸标识</div>
        <div class="value">{{ signInfo.faceFlagDesc }}</div>
      </div>
      <div class="info-item">
        <div class="label">人脸状态</div>
        <div class="value">{{ signInfo.faceStateDesc }}</div>
      </div>
      <div class="info-item">
        <div class="label">人脸描述</div>
        <div class="value">{{ signInfo.faceMsg }}</div>
      </div>
      <div class="info-item">
        <div class="label">身份证标识</div>
        <div class="value">{{ signInfo.idCardFlagDesc }}</div>
      </div>
    </div>
    <!-- 提交按钮 -->
    <div class="homecustom-btn">
      <van-button
        type="primary"
        :color="canSubmit ? '#FFA543' : '#FFCE98'"
        @click="onSubmit"
        block
      >
        下一步
      </van-button>
    </div>
    <van-toast id="van-toast" />
    <van-dialog confirm-button-color="#5280FE" id="van-dialog" />
  </div>
</template>

<script>
import { signIndexInfo } from '@/api/common'

export default {
  data() {
    return {
      signInfo: {},
      accountType: ''
    }
  },
  computed: {
    canSubmit() {
      return (
        this.signInfo.idCardFlag == 1 ||
        this.signInfo.faceFlag == 1 ||
        this.signInfo.cardAndTelFlag == 1
      )
    }
  },

  created() {
    let tmpstr = this.$route.query.accountType
    if (!tmpstr) {
      tmpstr = window.localStorage.getItem('accountType')
    }
    this.accountType = tmpstr || ''
    this.signIndexInfo()
    let version = this.$route.query.version || ''
    if (version) {
      window.localStorage.setItem('version', version)
    }
    let platform = this.$route.query.platform || ''
    if (platform) {
      window.localStorage.setItem('platform', platform)
    }
    window.localStorage.setItem('accountType', this.accountType)
  },
  methods: {
    signIndexInfo() {
      signIndexInfo({
        accountType: parseInt(this.accountType)
      }).then(res => {
        this.signInfo = res
        window.localStorage.setItem('signInfo', JSON.stringify(this.signInfo))
      })
    },
    onSubmit() {
      let path = ''
      if (this.signInfo.idCardFlag == 1) {
        // 身份证
        path = '/supply-info/idcard'
      } else if (this.signInfo.faceFlag == 1) {
        // 人脸
        path = '/supply-info/face'
      } else if (this.signInfo.cardAndTelFlag == 1) {
        // 银行卡
        path = '/supply-info/bankcard'
      }
      if (this.signInfo.signState == 3) {
        // 签约中
        this.$toast('签约中')
        this.signIndexInfo()
        return
      }
      this.$router.replace({
        path: path
      })
    }
  }
}
</script>
